const logs = {
	title: "Logs",
	details: "Log Details",
	id: "ID",
	user_id: "User",
	action: "Action",
	action_model: "Action Model",
	action_id: "Action ID",
	record: "Record",
	ip_address: "IP Address",
	created_at: "Date Created",
	field: "Field",
	before_values: "Before Values",
	after_values: "After Values",
};
export default logs;